import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setCreateBackupError, setLoading } from "../../repository/slice";

function* createBackupWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, "/api/backup/create", payload);
        if (isError) {
            yield put(setCreateBackupError(message));
        } else {
            yield put(setCreateBackupError(null));
        }
    } catch (error) {
        console.error("createBackupWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* createBackupWatcher() {
    yield takeLatest("@saga/CREATE_BACKUP", createBackupWorker);
};
